import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
var parse = function parse(search) {
  var pairs = search.slice(1).split('&');
  var result = pairs.reduce(function (prev, pair) {
    var _pair$split = pair.split('='),
      _pair$split2 = _slicedToArray(_pair$split, 2),
      key = _pair$split2[0],
      _pair$split2$ = _pair$split2[1],
      encodedValue = _pair$split2$ === void 0 ? '' : _pair$split2$;
    var value = decodeURIComponent(encodedValue);
    var arrValues = prev[key] && Array.isArray(prev[key]) ? prev[key] : [prev[key]];
    var arrValue = prev[key] ? [].concat(_toConsumableArray(arrValues), [value]) : value;
    return _objectSpread(_objectSpread({}, prev), key ? _defineProperty({}, key, arrValue) : {});
  }, {});
  return JSON.parse(JSON.stringify(result));
};
var stringify = function stringify(params) {
  var result = Object.keys(params).reduce(function (prev, key) {
    var valueArray = Array.isArray(params[key]) ? params[key] : [params[key]];
    return valueArray.reduce(function (prevValue, decodedValue) {
      var value = encodeURIComponent(decodedValue);
      var amp = prevValue.length > 0 ? '&' : '';
      return "".concat(prevValue).concat(amp).concat(key, "=").concat(value);
    }, prev);
  }, '');
  return JSON.parse(JSON.stringify(result));
};
var index = {
  parse: parse,
  stringify: stringify
};
export default index;